import { IMG_KV } from "../const";
import style from "./slider.css";

const kzs = window.kzs;
const $ = kzs.$;

export const changeSliderDesign = (): void => {
  style.use();

  // slick
  const tid = setInterval(function () {
    if (!window.$.fn.slick) return;
    clearInterval(tid);
    kzs.console.log("kaizen: slick plugin loaded");

    let sliderItems = "";
    $.each(IMG_KV, (_i, v) => {
      sliderItems += `
        <div>
          <a href="${v.href}" onclick="${v.onclick}">
            <img src="${v.src}" alt="${v.alt}">
          </a>
        </div>
        `;
    });

    $(".l-mainvisual").append(`
        <div class="kz-slider">
          ${sliderItems}
        </div>
      `);
    $("#rtoaster_top_pfa_sp").hide();
    window.$(".kz-slider").slick({
      dots: true,
      arrows: false,
      infinite: true,
      // speed: 1000,
      // fade: true,
      // cssEase: "linear",
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 10000,
      appendDots: ".l-mainvisual",
      dotsClass: "slick-dots kz-slick-dots",
    });

    // スライダー
    $(".kz-slider .slick-slide[aria-describedby^=slick-slide]").each((_i, e) => {
      const $mainSlideLi = $(e);

      $(`li#${$mainSlideLi.attr("aria-describedby")} button`).append(
        $("<span>")
          .addClass("kz-slide-thumb-img")
          .css("background-image", "url(" + $mainSlideLi.find("img").attr("src") + ")")
      );

      const slideText = $mainSlideLi.find("img").attr("alt");
      if (slideText) {
        $(`li#${$mainSlideLi.attr("aria-describedby")} button`)
          .append($("<span>").addClass("kz-slide-anime"))
          .append($("<span>").addClass("kz-slide-text").text(slideText));
      }
    });

    // init
    $(".kz-slider .slick-slide, .kz-slick-dots li").removeClass("slick-active");
    setTimeout(() => {
      $(".kz-slider .slick-slide[data-slick-index=0], .kz-slick-dots li:first-of-type").addClass("slick-active");
    }, 10);
  }, 300);
};
